<template>
  <div>
    <div @click.stop="playVideo" class="video-boxCon">

      <div id="J_prismPlayer" ref="J_prismPlayer" class="video-box prism-player" v-if="detail.tags == '视频'"
        controlslist="nodownload"></div>
      <div id="J_prismPlayer" ref="J_prismPlayer" class="video-box prism-player" v-else-if="detail.tags == '音乐'"
        controlslist="nodownload"></div>
      <img :src="detail.vediourl" alt="" v-else-if="detail.tags == '图片'" @click.stop="download2" class="vediourlImg" />

      <template v-if="showTools">
        <div class="toolBarClass">
          <div class="toolBarClassChild">
            <img :src="muted ? voiceOpenImg2 : voiceCloseImg2" alt="" class="mutedImg" @click.stop="isMuted"
              v-if="detail.tags == '视频' || detail.tags == '音乐'" />
            <img src="../../static/img/sellingTime/fullscreen.png" alt="" @click="tofullscreen" class="fullscreenImg"
              v-if="detail.tags == '视频' || detail.tags == '音乐'" />
            <div class="btn3d" v-if="dataObj.show3DpageBtn == true" @click="goShow3DPage">
              <img src="../../static/img/sellingTime/3dIcon.png" alt="" class="btn3DImg" />
              <!-- 3D空间 -->
            </div>
            <!-- <div @click="sharemodalTrue" class="shareImgView">
          <img src="/static/img/sellingTime/share.png" alt="" class="shareImg" />
        </div> -->
            <div v-if="YHhideFunBtnFlag" @click="YHhideFun" class="shareImgView">
              <img src="/static/img/sellingTime/YHhideFunBtn.png" alt="" class="shareImg" />
            </div>
          </div>
        </div>

      </template>
      <Share :modal="sharemodal" @handleshare="handleshare" :isDownload="dataObj.isDownload" :downUrl="downloadUrl"
        :workshow="workshow" :isBoxFlag="isBoxFlag" :userId="dataObj.userId"></Share>
      <!-- <a v-if="!androidVx" :href="downloadUrl" :download="downloadUrl" class="downloadImg"></a>
      <a v-else href="javascript:void(0)" @click="adownload" class="downloadImg"></a> -->
    </div>
  </div>
</template>
<script>
  import Share from "@/components/Share.vue";
  import sss from "weixin-js-sdk";
  export default {
    name: "videoModel",
    components: {
      Share,
    },
    data() {
      return {
        hideVideoView: false,
        androidVx: false,
        downloadUrl: "",
        voiceOpenImg2: "../../static/img/sellingTime/muted1.png",
        voiceCloseImg2: "../../static/img/sellingTime/muted2.png",
        muted: true,
        detail: {},
        sharemodal: {
          value: false,
        },
        workshow: true,
        isBoxFlag: 3,
      };
    },
    props: {
      dataObj: Object,
      isFullscreen: Boolean,
      showTools: {
        type: Boolean,
        default: true,
      },
      YHhideFunBtnFlag: Boolean,
      // opusattrid,
      // id,
    },
    watch: {},
    filters: {},
    computed: {},
    methods: {
      //禁止滚动
      stop() {
        document.getElementsByTagName('body')[0].setAttribute('style', 'position:fixed; width:100%;font-size:12px')
      },
      /***取消滑动限制***/
      move() {
        document.getElementsByTagName('body')[0].setAttribute('style', 'position:relative;font-size:12px')
      },
      sharemodalTrue() {
        this.sharemodal.value = true
        this.stop()
        this.hideVideoView = true

      },
      adownload() {
        // alert("微信不支持下载，请点击右上角使用其它浏览器打开！");
        alert(that.$i18nn.t('share.dontSuppot'))
        return;
      },

      /**
       * @description 分享
       */
      handleshare({
        nativeShare,
        type,
        copyUrl,
        isnormal,
        downloadUrl
      }) {
        const {
          name,
          intro,
          opusstorage
        } = this.detail;
        let row = opusstorage.find((item) => item.opustype === 2);
        let icon = row ? row.externalurl : "";
        nativeShare.setShareData({
          icon,
          link: window.location.href,
          title: name,
          desc: isnormal ? intro : name,
          // from: "@fa-ge",
        });
        try {
          if (type != "download") {
            nativeShare.call(type, downloadUrl);
          }
        } catch (err) {
          //如果是下载 就不调用复制url方法
          if (type == "download") {
            // this.downloadUrl
            this.download();
            // return;
          } else {
            copyUrl();
          }
          // this.$toast({
          //   message: "暂不支持",
          // });
        }
      },
      // 乐华隐藏按钮按钮点击
      YHhideFun() {
        this.muted = true
        this.mutedImg = this.muted ? this.voiceCloseImg : this.voiceOpenImg;
        this.player.setVolume(this.muted ? 0 : 1);
        this.$emit('YHhideFun')
      },
      //是否静音
      isMuted() {
        this.muted = !this.muted;
        this.mutedImg = this.muted ? this.voiceCloseImg : this.voiceOpenImg;
        this.player.setVolume(this.muted ? 0 : 1);
      },
      onPlayerPlay() {
        const player = this.$refs.videoPlayer.player;
        player.play();
      },
      onPlayerPause() {
        // alert("pause");
        const player = this.$refs.videoPlayer.player;
        player.pause;
      },
      createPlayer(src, poster) {
        var that = this;
        if (!src || this.player) {
          return;
        }
        this.player = new Aliplayer({
            id: "J_prismPlayer",
            width: "100%",
            height: "100%",
            videoWidth: "100%",
            videoHeight: "100%",
            controlslist: "nodownload",
            autoplay: true,
            cover: poster,
            rePlay: true,
            useH5Prism: true,
            playsinline: true,
            "x5-video-player-type": "h5",
            // "x-webkit-airplay": "allow",
            // "x5-video-player-type": "h5", //　启用H5播放器,是wechat安卓版特性
            // "x5-video-player-fullscreen": "true", //　全屏设置，设置为 true 是防止横屏
            // "x5-video-orientation": "por,//traint", //　播放器支付的方向，landscape横屏，portraint竖屏，默认值为竖屏
            // "webkit-playsinline": "true", //　这个属性是ios 10中设置可以让视频在小窗内播放，也就是不是全屏播放
            // "playsinline": "true", //IOS微信浏览器支持小窗内播放
            // x5_video_position: 'top', // 播放窗口在上
            // x5_type: 'h5', //声明启用同层H5播放器，支持的值：h5
            source: src,
            preload: "auto",
            skinLayout: [],
          },
          function (player) {
            player.setVolume(0);
            player.play();
            if (that.isFullscreen) player.fullscreenService.requestFullScreen();
          }
        );
        this.$nextTick(() => {
          // this.$refs.J_prismPlayer.removeAttribute("x5-playsinline");
          // this.$refs.J_prismPlayer.children[0].removeAttribute("x5-playsinline");
          // this.$refs.J_prismPlayer.removeAttribute("webkit-playsinline");
          // this.$refs.J_prismPlayer.children[0].removeAttribute("webkit-playsinline");
          // this.$refs.J_prismPlayer.children[0].setAttribute(
          //   "x5-video-player-type",
          //   "h5"
          // );
          wx.config({
            debug: false,
            appId: "111",
            timestamp: "111",
            nonceStr: "111",
            signature: "111",
            jsApiList: [],
          });
          wx.ready(() => {
            that.$nextTick(() => {
              that.player.setVolume(0);
              that.player.play();
            });
          });
        });
      },
      tofullscreen() {
        // this.player.requestFullscreen() //调用全屏api方法
        // this.player.isFullscreen(true)
        // this.player.play()
        // fullscreenService.requestFullScreen
        this.player.fullscreenService.requestFullScreen();
      },
      adownload() {
        // alert("微信不支持下载，请点击右上角使用其它浏览器打开！");
        alert(that.$i18nn.t('share.dontSuppot'))
        return;
      },
      // 作品下载
      download() {
        // let that = this;
        // var isAndroid =
        //   navigator.userAgent.indexOf("Android") > -1 ||
        //   navigator.userAgent.indexOf("Linux") > -1;
        // var isWeiXin =
        //   navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ?
        //   true :
        //   false;
        // if (isWeiXin && isAndroid) {
        //   that.androidVx = true;
        // }
        // if (!this.$store.state.token) {
        //   this.$router.push({
        //     path: "/login",
        //     query: {
        //       redirect: this.$route.fullPath,
        //     },
        //   });
        //   return;
        // }
        // if (that.$store.state.token) {
        //   that.$fetchql
        //     .Post("opus/hd", {
        //       opusId: this.$route.query.id - 0,
        //       opusAttrId: this.$route.query.opusattrid - 0,
        //     })
        //     .then((res) => {
        //       that.downloadUrl = that.$baseUrl + res.data;
        //     });
        // }

      },
      // 作品下载
      download() {
        let that = this;
        var isAndroid =
          navigator.userAgent.indexOf("Android") > -1 ||
          navigator.userAgent.indexOf("Linux") > -1;
        var isWeiXin =
          navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ?
          true :
          false;
        if (isWeiXin && isAndroid) {
          that.androidVx = true;
        }
        if (!that.$store.state.token) {
          that.$router.push({
            path: "/login",
            query: {
              redirect: that.$route.fullPath,
            },
          });
          return;
        }
        if (that.$route.query.opusattrid && that.$store.state.token) {
          that.$fetchql
            .Post("opus/hd", {
              opusId: that.$route.query.id - 0,
              opusAttrId: that.$route.query.opusattrid - 0,
            })
            .then((res) => {
              if (!res.data) {
                that.downloadUrl = "";
                return;
              } else {
                that.downloadUrl = that.$baseUrl + res.data;
              }
            });
        }
      },
      // 作品下载
      download2() {
        window.open(this.detail.vediourl);
      },
      playVideo() {
        if (this.detail.tags == "图片") return;
        this.player.play();
        // this.player.setVolume(1);
        this.mutedImg = this.muted ? this.voiceCloseImg : this.voiceOpenImg;
      },
      // 跳转3d空间
      // id: that.dataObj.id * 1,
      //         opusattrid: that.dataObj.opusattrid,
      goShow3DPage() {
        if (this.detail.opusmodel && this.detail.opusmodel.issupportanimaiton == 1) {
          this.$router.push({
            path: "/page3DAnimate",
            query: {
              opusattrid: this.dataObj.opusattrid,
              id: this.dataObj.id,
              num: this.detail.opusattrs[0].code,
              maxNum: this.detail.qty,
              creator: this.detail.creatoropusrelations[0].creator.name,
            },
          });
        } else {
          this.$router.push({
            path: "/page3D",
            query: {
              opusattrid: this.dataObj.opusattrid,
              id: this.dataObj.id,
              num: this.detail.opusattrs[0].code,
              maxNum: this.detail.qty,
              creator: this.detail.creatoropusrelations[0].creator.name,
            },
          });
        }

      },
      getData() {
        //作品详情
        let that = this;
        that.$fetchql
          .hasura({
            fn: "opus.querydetailbyid",
            variables: {
              id: that.dataObj.id * 1,
              opusattrid: that.dataObj.opusattrid,
            },
          })
          .then((res) => {
            var data = res.data.opus[0];

            data.opusstorage.forEach((item) => {
              item.externalurl = that.$baseUrl + item.externalurl;
              if (item.opustype == 1) {
                data.vediourl = item.externalurl;
              } else if (item.opustype == 2) {
                data.imgurl = item.externalurl;
              }
            });
            this.$set(this.detail, Object.assign(this.detail, data));
            that.$nextTick(() => {
              if (data.tags == "视频" || data.tags == "音乐") {
                that.createPlayer(
                  that.detail.vediourl,
                  that.detail.vediourl +
                  "?x-oss-process=video/snapshot,t_1000,f_jpg,m_fast"
                );
                var u = navigator.userAgent,
                  app = navigator.appVersion;
                var isAndroid =
                  u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if (isAndroid) {
                  setTimeout(function () {
                    that.muted = false;
                    that.mutedImg = this.muted ?
                      this.voiceCloseImg :
                      this.voiceOpenImg;
                    that.player.setVolume(1);
                  }, 500);
                }
              }
            });
          });

      },
    },
    mounted() {
      this.$nextTick(() => {
        console.log("......");
        console.log(this.dataObj);
        if (this.dataObj.id) this.getData();
        if (this.$store.state.token) this.download();
      });

    },
    destroyed() {
      this.player.pause();
      this.move()
    },
  };

</script>
<style scoped="scoped" lang="less">
  .video-boxCon {
    // position: relative;
    height: 460px;
    z-index: 1;
    text-align: center;

    .toolBarClass {
      position: absolute;
      width: 100%;
      height: 100px;
      background: url(/static/img/sellingTime/vediourlBg.png)no-repeat;
      background-size: 100% 100px;
      bottom: -20px;
      z-index: 1;
      text-align: center;
      // display: flex;
      // justify-content: center;
      // align-content: center;
      // align-items: center;

      .toolBarClassChild {
        height: 30px;
        background: #404040;
        display: inline-block;
        margin-top: 42px;
      }
    }
  }

  .video-box {
    position: relative;
    overflow: hidden;
    font-size: 0;
    // width: 295px !important;
    height: 295px;
    margin: 0 auto;
  }

  /deep/ #J_prismPlayer {
    text-align: center !important;
  }

  /deep/ .prism-player video {
    object-fit: contain;
    // width: auto !important;
    // position: static !important;
    // left: 0 !important;
    // top: 0 !important;
    // transform: translate(0%, 0%) !important;
    // object-position: 50% 50% !important;
    // object-fit: contain;
  }

  .mutedImg {
    width: 16.5px !important;
    height: 16.5px !important;
    position: absolute !important;
    left: 15px !important;
    z-index: 9 !important;
    top: 50px;
  }

  /deep/ #J_prismPlayer {
    text-align: center !important;
  }

  .shareImgView {
    margin-top: 15px;
    display: inline-block;

    .shareImg {
      width: 35px;
      height: 35px;
      z-index: 2;
      display: inline-block;
      margin-left: 15px;
    }
  }

  .btn3d {
    // position: absolute;
    // right: 55px;
    // top: 15px;
    margin-top: 6px;
    width: 16px;
    display: inline-block;
    height: 17px;
    margin-right: 6px;
    margin-left: 6px;
    z-index: 1;

    .btn3DImg {
      width: 16px;
      height: 17px;
    }
  }

  .fullscreenImg {
    // position: absolute !important;
    // right: 55px !important;
    // top: -45px !important;
    width: 16px !important;
    height: 17px !important;
    z-index: 9 !important;
    display: inline-block;
    margin-top: 6px;
    margin-left: 6px;
    margin-right: 6px;
    // bottom: 3px;
  }

  .downloadImg {
    position: absolute;
    right: 40px;
    bottom: 10px;
    width: 29px;
    height: 29px;
    z-index: 9999;
    background: url(../../static/img/sellingTime/download.png);
    background-size: 100% 100%;
  }

  video::-webkit-media-controls-fullscreen-button {
    display: none;
  }

  video::-webkit-media-controls-play-button {}

  video::-webkit-media-controls-timeline {}

  video::-webkit-media-controls-current-time-display {}

  video::-webkit-media-controls-time-remaining-display {}

  video::-webkit-media-controls-mute-button {}

  video::-webkit-media-controls-toggle-closed-captions-button {}

  video::-webkit-media-controls-volume-slider {}

</style>



// WEBPACK FOOTER //
// src/components/videoModel.vue